exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg.active[data-v-29ec9e4a]{color:#0078b6!important}svg.inactive[data-v-29ec9e4a]{color:#dee5ea!important}", ""]);

// exports
